/** YouTube Banner — document knowledge definition. Pure data. */
export default {
  id: 'youtube-banner',
  name: 'YouTube Banner',
  description: 'The channel header art that brands a creator across all devices.',
  purpose: 'Channel Branding',
  recommendedSizes: [{ name: 'Channel Art', width: 2560, height: 1440, unit: 'px' }],
  supportedOrientations: ['landscape'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Channel Name', 'Tagline', 'Upload Schedule', 'Social Handles', 'Background Art'],
};
